import * as React from "react";
import { forwardRef } from "react";
const SvgChevron = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14.1663 8.33334L9.99967 12.5L5.83301 8.33334", stroke: "#40494D", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgChevron);
export { ForwardRef as ReactComponent };
